






















import { Component, Vue } from 'vue-property-decorator';
import gql from 'graphql-tag';

@Component({
  components: {},
})
export default class Center extends Vue {
  public centerQuery = gql`
    query Center($id: ID, $code: String) {
      center(id: $id, code: $code) {
        id
        centerCode
        name
        lanes
      }
    }
  `;

  get centerCodeOrId() {
    return this.$route.params.centerCodeOrId;
  }
}
